import { render, staticRenderFns } from "./ChangeMedecinPatient.vue?vue&type=template&id=67c52590&scoped=true"
import script from "./ChangeMedecinPatient.vue?vue&type=script&lang=js"
export * from "./ChangeMedecinPatient.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ChangeMedecinPatient.vue?vue&type=style&index=1&id=67c52590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c52590",
  null
  
)

export default component.exports